// Components==============
import { faAngleDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AnimatePresence, motion } from 'framer-motion';
import React, { useState } from 'react';
import './index.module.scss';
// =========================

const framerArrow = {
    open: {
        rotate: 180,
    },
    closed: {
        rotate: 0,
    },
};

const framerMenu = {
    open: {
        height: 'auto',

        transition: {
            delayChildren: 0.1,
            staggerChildren: 0.05,
        },
    },
    closed: {
        height: 0,
    },
};

const framerMenuItem = {
    open: {
        opacity: 1,
    },
    closed: {
        opacity: 0,
        transition: {
            duration: 0.1,
        },
    },
};

export default function SingleItemDropdown({
    text,
    options,
    selected,
    setSelected,
    label,
    style,
    white,
}) {
    const [isDropped, setIsDropped] = useState(false);

    function handleClick(option) {
        setSelected(option);
        setIsDropped(false);
    }

    return (
        <>
            {label && <label>{label}</label>}
            <motion.div
                initial="closed"
                animate={isDropped ? 'open' : 'closed'}
                styleName={`wrapper ${isDropped ? 'menuIsOpen' : ''}`}
            >
                <div
                    styleName="button"
                    onClick={() => setIsDropped((prev) => !prev)}
                    style={{
                        ...style,
                        backgroundColor: white ? '#ffffff' : '',
                    }}
                >
                    <p style={{ color: white ? '#1e265c' : '' }}>{text}</p>
                    <motion.button variants={framerArrow} type="button">
                        <FontAwesomeIcon
                            icon={faAngleDown}
                            style={{ color: white ? '#1e265c' : '' }}
                        />
                    </motion.button>
                </div>
                <AnimatePresence>
                    {isDropped && (
                        <motion.div
                            styleName="menu"
                            variants={framerMenu}
                            exit="closed"
                            initial="closed"
                            animate={isDropped ? 'open' : 'closed'}
                            style={{
                                backgroundColor: white ? '#ffffff' : '',
                                color: white ? '#1e265c' : '',
                            }}
                        >
                            <div styleName="padding">
                                {options.map((option) => {
                                    const isSelected = selected === option;

                                    return (
                                        <motion.div
                                            key={option}
                                            variants={framerMenuItem}
                                            styleName="menu-item"
                                            onClick={() => handleClick(option)}
                                        >
                                            <motion.p
                                                whileHover={{ x: 2 }}
                                                style={{
                                                    fontWeight: isSelected
                                                        ? 600
                                                        : 400,
                                                }}
                                            >
                                                {option}
                                            </motion.p>
                                        </motion.div>
                                    );
                                })}
                            </div>
                        </motion.div>
                    )}
                </AnimatePresence>
            </motion.div>
        </>
    );
}
